export { AgeAssuranceGate } from './components/age-assurance-gate';
